import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_PAYMENT_ITEM',
    icon: 'menu-payment',
    label: '款项',
    path: '/base-data/payment-item',
  },
] satisfies Menu[];
